/* Everwell paper layer: statement revealed by a circle on scroll, steps swap the sticky card. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* statement: the ink fills from the centre in three cable layers as the sentence moves up the screen */
  document.querySelectorAll('[data-ep-reveal]').forEach(function (el) {
    var rings = Array.prototype.slice.call(el.querySelectorAll('.ep-statement__rings i'));
    var layers = [0.24, 0.55, 1.02]; // ring radii as a share of the half-diagonal: conductor, insulation, sheath
    var half = 0, step = -1;
    var size = function () {
      half = Math.sqrt(el.offsetWidth * el.offsetWidth + el.offsetHeight * el.offsetHeight) / 2;
      rings.forEach(function (r, i) { r.style.setProperty('--ring', (layers[i] * half).toFixed(1) + 'px'); });
    };
    var set = function (s) {
      el.style.setProperty('--r', (s ? layers[s - 1] * half : 0).toFixed(1) + 'px');
      if (s === step) return;
      rings.forEach(function (r, i) {
        r.classList.toggle('is-on', i < s && s < layers.length);
        if (s > step && i === s - 1) { r.classList.remove('is-hit'); void r.offsetWidth; r.classList.add('is-hit'); }
      });
      step = s;
    };
    if (reduce) { size(); set(layers.length); return; }
    var tick = function () {
      var vh = window.innerHeight;
      // 0 when the top of the text is at 75% of the screen, full at 40%
      var p = (vh * 0.75 - el.getBoundingClientRect().top) / (vh * 0.35);
      set(p < 0.08 ? 0 : p < 0.42 ? 1 : p < 0.76 ? 2 : 3);
    };
    size();
    var queued = false;
    window.addEventListener('scroll', function () {
      if (queued) return; queued = true;
      window.requestAnimationFrame(function () { queued = false; tick(); });
    }, { passive: true });
    window.addEventListener('resize', function () { size(); step = -1; tick(); });
    tick();
  });

  /* site plan drawing, shared by the plan hero and the steps panel: an orthogonal run with rounded bends,
   shifted sideways by o (bends stay concentric) */
  function epRun(pts, o, r) {
    var dir = function (a, b) { var dx = b[0] - a[0], dy = b[1] - a[1], l = Math.hypot(dx, dy) || 1; return [dx / l, dy / l]; };
    var nrm = function (d) { return [-d[1], d[0]]; };
    var out = [];
    for (var i = 0; i < pts.length; i++) {
      var din = i ? dir(pts[i - 1], pts[i]) : dir(pts[0], pts[1]);
      var dout = i < pts.length - 1 ? dir(pts[i], pts[i + 1]) : din;
      var n1 = nrm(din), n2 = nrm(dout), same = i === 0 || i === pts.length - 1;
      out.push({ p: same ? [pts[i][0] + n1[0] * o, pts[i][1] + n1[1] * o] : [pts[i][0] + (n1[0] + n2[0]) * o, pts[i][1] + (n1[1] + n2[1]) * o], din: din, dout: dout });
    }
    var d = 'M' + out[0].p[0] + ' ' + out[0].p[1];
    for (var j = 1; j < out.length - 1; j++) {
      var c = out[j], cross = c.din[0] * c.dout[1] - c.din[1] * c.dout[0];
      var rc = r - o * Math.sign(cross);
      d += 'L' + (c.p[0] - c.din[0] * rc) + ' ' + (c.p[1] - c.din[1] * rc);
      d += 'A' + rc + ' ' + rc + ' 0 0 ' + (cross > 0 ? 1 : 0) + ' ' + (c.p[0] + c.dout[0] * rc) + ' ' + (c.p[1] + c.dout[1] * rc);
    }
    var e = out[out.length - 1].p;
    return d + 'L' + e[0] + ' ' + e[1];
  }

  var EP_ROOMS = [[40, 120, 190, 130, 'SUBSTATION'], [470, 40, 230, 90, 'MSB ROOM'], [880, 400, 150, 110, 'DB-2'],
    [60, 640, 260, 180, 'BLOCK A'], [1160, 430, 230, 110, 'GENSET'], [700, 600, 170, 120, 'DB-3'], [1020, 30, 150, 70, 'DB-1']];
  var EP_PITS = [[300, 350], [560, 440], [820, 180], [1300, 760], [960, 260]];
  var EP_BUNDLES = [
    [[-40, 350], [300, 350], [300, 180], [820, 180], [820, -40]],
    [[-40, 600], [170, 600], [170, 440], [560, 440], [560, 290], [1480, 290]],
    [[1480, 760], [1300, 760], [1300, 580], [1060, 580], [1060, 980]]
  ];
  var EP_ROUTE = [[1400, -40], [1400, 120], [960, 120], [960, 260], [640, 260], [640, 400], [220, 400], [220, 480]];

  /* steps: the step nearest the middle of the screen is active; its card shows in the sticky panel */
  document.querySelectorAll('[data-ep-steps]').forEach(function (root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-ep-step]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('.ep-steps__panel [data-ep-card]'));
    /* the panel behind the cards: the hero's site plan in light lines. Each step lays one more bundle; the
       last step draws the red route to its end marker. */
    var plan = root.querySelector('.ep-steps__panel .ep-plan');
    var drawn = [];
    if (plan) {
      var NS = 'http://www.w3.org/2000/svg';
      var el = function (parent, tag, attrs, text) {
        var e = document.createElementNS(NS, tag);
        Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); });
        if (text) e.textContent = text;
        parent.appendChild(e);
        return e;
      };
      for (var gx = 0; gx <= 1440; gx += 48) el(plan, 'path', { d: 'M' + gx + ' 0V900', class: 'ep-plan__grid' });
      for (var gy = 0; gy <= 900; gy += 48) el(plan, 'path', { d: 'M0 ' + gy + 'H1440', class: 'ep-plan__grid' });
      EP_ROOMS.forEach(function (b) {
        el(plan, 'rect', { x: b[0], y: b[1], width: b[2], height: b[3], class: 'ep-plan__room' });
        el(plan, 'text', { x: b[0] + 10, y: b[1] + 20, class: 'ep-plan__label' }, b[4]);
      });
      EP_PITS.forEach(function (m) { el(plan, 'rect', { x: m[0] - 9, y: m[1] - 9, width: 18, height: 18, class: 'ep-plan__pit' }); });
      EP_BUNDLES.forEach(function (pts) {
        var g = el(plan, 'g', { class: 'ep-plan__bundle' });
        [0, 11, 22, 33].forEach(function (o, k) {
          el(g, 'path', { d: epRun(pts, o, 40), pathLength: 1, class: k ? 'ep-plan__cable' : 'ep-plan__cable ep-plan__cable--lead' });
        });
        drawn.push(g);
      });
      var rd = epRun(EP_ROUTE, 0, 40);
      var mask = el(el(plan, 'defs', {}), 'mask', { id: 'ep-steps-mask', maskUnits: 'userSpaceOnUse', x: 0, y: 0, width: 1440, height: 900 });
      el(mask, 'path', { d: rd, pathLength: 1, class: 'ep-plan__reveal' });
      el(plan, 'path', { d: rd, class: 'ep-plan__route', mask: 'url(#ep-steps-mask)' });
      var end = el(plan, 'g', { class: 'ep-plan__end' });
      el(end, 'circle', { cx: 220, cy: 480, r: 14 });
      el(end, 'circle', { cx: 220, cy: 480, r: 5, class: 'ep-plan__end-dot' });
      drawn.push(mask, end);
    }
    var set = function (i) {
      steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      cards.forEach(function (c, k) { c.classList.toggle('is-active', k === i); });
      /* steps 1-3 lay bundles 1-3; the last step adds the route and its end marker */
      var last = steps.length - 1;
      drawn.forEach(function (d, k) { d.classList.toggle('is-on', k < 3 ? k <= i : i >= last); });
    };
    set(0);
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) set(steps.indexOf(en.target)); });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    steps.forEach(function (s) { io.observe(s); });
  });

  var onScroll = function (fn) {
    var queued = false;
    window.addEventListener('scroll', function () {
      if (queued) return; queued = true;
      window.requestAnimationFrame(function () { queued = false; fn(); });
    }, { passive: true });
    window.addEventListener('resize', fn);
    fn();
  };
  var whenSeen = function (els, fn, margin) {
    if (!('IntersectionObserver' in window)) { els.forEach(fn); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); fn(en.target); } });
    }, { rootMargin: margin || '0px 0px -15% 0px' });
    els.forEach(function (el) { io.observe(el); });
  };

  /* headings: split into the lines the browser drew, raise each line once, then put the plain text back */
  if (!reduce) {
    var heads = Array.prototype.slice.call(document.querySelectorAll('.ep .ep-h2, .ep h2.ep-h1, .ep .ep-hero__title')).filter(function (h) {
      /* the closing prompt runs its own word-by-word fade */
      return !h.children.length && h.textContent.trim() && !h.closest('.ep-cta');
    });
    heads.forEach(function (h) {
      var text = h.textContent.trim().replace(/\s+/g, ' ');
      h.innerHTML = text.split(' ').map(function (w) { return '<span>' + w + '</span>'; }).join(' ');
      var lines = [], top = null;
      Array.prototype.forEach.call(h.children, function (w) {
        if (w.offsetTop !== top) { lines.push([]); top = w.offsetTop; }
        lines[lines.length - 1].push(w.textContent);
      });
      h.innerHTML = lines.map(function (l, i) {
        return '<span class="ep-line"><span style="--i:' + i + '">' + l.join(' ') + '</span></span>';
      }).join('');
      h.classList.add('ep-lines');
      h.setAttribute('aria-label', text);
      h.dataset.text = text;
    });
    whenSeen(heads, function (h) {
      h.getBoundingClientRect();
      window.requestAnimationFrame(function () { h.classList.add('is-up'); });
      var n = h.querySelectorAll('.ep-line').length;
      setTimeout(function () { h.textContent = h.dataset.text; h.classList.remove('ep-lines', 'is-up'); h.removeAttribute('aria-label'); }, 900 + n * 90 + 100);
    });
  }

  /* figures: every digit becomes a reel that rolls one full turn and stops on its value */
  if (!reduce) {
    var figs = Array.prototype.slice.call(document.querySelectorAll('.ep-stat dt'));
    figs.forEach(function (dt) {
      var text = dt.textContent.trim(), k = 0, reel = '';
      for (var d = 0; d < 20; d++) reel += '<span>' + (d % 10) + '</span>';
      dt.setAttribute('aria-label', text);
      dt.innerHTML = text.split('').map(function (c) {
        if (!/\d/.test(c)) return '<span aria-hidden="true">' + c + '</span>';
        return '<span class="ep-odo" aria-hidden="true"><span class="ep-odo__reel" data-d="' + c + '" style="--k:' + (k++) + '">' + reel + '</span></span>';
      }).join('');
    });
    whenSeen(figs, function (dt) {
      Array.prototype.forEach.call(dt.querySelectorAll('.ep-odo__reel'), function (r) {
        r.style.translate = '0 -' + (10 + Number(r.dataset.d)) + 'em';
      });
    }, '0px 0px -20% 0px');
  }

  /* drum tags: the section pins, the wire draws across, then each tag swings up and hangs */
  document.querySelectorAll('[data-ep-tags]').forEach(function (root) {
    var tags = Array.prototype.slice.call(root.querySelectorAll('[data-ep-tag]'));
    var hang = function (tag, t) {
      tag.style.setProperty('--t', t.toFixed(3));
      var hung = t >= 1;
      if (hung && !tag.classList.contains('is-hung')) tag.classList.add('is-hung');
      if (t <= 0.5) tag.classList.remove('is-hung');
    };
    if (reduce) { root.style.setProperty('--wire', 1); tags.forEach(function (t) { hang(t, 1); }); return; }
    var narrow = window.matchMedia('(max-width: 899px)');
    if (narrow.matches) {
      whenSeen(tags, function (t) { hang(t, 1); }, '0px 0px -10% 0px');
      return;
    }
    var ease = function (x) { return 1 - Math.pow(1 - x, 3); };
    onScroll(function () {
      var r = root.getBoundingClientRect();
      var span = r.height - window.innerHeight;
      var p = span > 0 ? Math.max(0, Math.min(1, -r.top / span)) : 1;
      root.style.setProperty('--wire', Math.min(1, p / 0.14).toFixed(3));
      var slot = (0.92 - 0.14) / tags.length;
      tags.forEach(function (tag, i) {
        var t = (p - 0.14 - i * slot) / slot;
        hang(tag, ease(Math.max(0, Math.min(1, t))));
      });
    });
  });

  /* single-line diagram: the section pins, the supply feeds the busbar, then each breaker closes in turn
     and its branch goes live; on phones each branch closes as it scrolls into view */
  document.querySelectorAll('[data-ep-sld]').forEach(function (root) {
    var branches = Array.prototype.slice.call(root.querySelectorAll('[data-ep-branch]'));
    var close = function (b, t) {
      b.style.setProperty('--t', t.toFixed(3));
      b.classList.toggle('is-live', t >= 1);
    };
    var live = function () {
      root.style.setProperty('--feed', 1); root.style.setProperty('--bus', 1); root.classList.add('is-bus');
    };
    if (reduce) { live(); branches.forEach(function (b) { close(b, 1); }); return; }
    if (window.matchMedia('(max-width: 899px)').matches) {
      live();
      whenSeen(branches, function (b) { close(b, 1); }, '0px 0px -25% 0px');
      return;
    }
    var clamp = function (x) { return Math.max(0, Math.min(1, x)); };
    onScroll(function () {
      var r = root.getBoundingClientRect();
      var span = r.height - window.innerHeight;
      var p = span > 0 ? clamp(-r.top / span) : 1;
      var bus = clamp((p - 0.05) / 0.12);
      root.style.setProperty('--feed', clamp(p / 0.06).toFixed(3));
      root.style.setProperty('--bus', bus.toFixed(3));
      root.classList.toggle('is-bus', bus >= 1);
      var slot = (0.92 - 0.2) / branches.length;
      branches.forEach(function (b, i) {
        var t = clamp((p - 0.2 - i * slot) / slot);
        close(b, bus >= 1 ? t * t : 0);
      });
    });
  });

  /* steps: lay the cable from the drum down to the line at 55% of the screen; markers fill as it passes */
  document.querySelectorAll('[data-ep-run]').forEach(function (list) {
    var run = list.querySelector('.ep-run');
    var steps = Array.prototype.slice.call(list.querySelectorAll('.ep-step'));
    var ys = [], top = 0, h = 0;
    var layout = function () {
      var base = list.getBoundingClientRect().top;
      ys = steps.map(function (s) {
        var r = s.querySelector('.ep-step__num').getBoundingClientRect();
        return r.top + r.height / 2 - base;
      });
      var drum = Math.max(0, ys[0] - 96);
      top = drum + run.querySelector('.ep-run__drum').getBoundingClientRect().height;
      h = Math.max(0, ys[ys.length - 1] - top);
      run.style.setProperty('--drum-y', drum + 'px');
      run.style.setProperty('--run-top', top + 'px');
      run.style.setProperty('--run-h', h + 'px');
    };
    var tick = function () {
      var base = list.getBoundingClientRect().top, line = window.innerHeight * 0.55;
      var p = reduce ? 1 : Math.max(0, Math.min(1, (line - base - top) / (h || 1)));
      run.style.setProperty('--run', p.toFixed(4));
      steps.forEach(function (s, i) { s.classList.toggle('is-reached', reduce || base + ys[i] <= line + 1); });
    };
    layout();
    window.addEventListener('resize', layout);
    window.addEventListener('load', function () { layout(); tick(); });
    onScroll(tick);
  });

  /* hero: four cores lie side by side; while the pinned hero scrolls they twist into a laid-up cable, the
     armour wires wrap over them and the sheath is pulled on, leaving a prepared end (wide screens) */
  document.querySelectorAll('[data-ep-twist]').forEach(function (hero) {
    var cv = hero.querySelector('.ep-twist');
    var pin = hero.querySelector('.ep-hero__pin');
    var cap = hero.querySelector('.ep-twist__step');
    if (!cv || !cv.getContext || !pin) return;
    var ctx = cv.getContext('2d');
    var wide = window.matchMedia('(min-width: 1000px)');
    /* brown, black, grey, blue: base, highlight, edge */
    var CORES = [['#7b4a2c', '#a8744e', '#3f2414'], ['#2b2b2b', '#5c5c5c', '#0d0d0d'], ['#8c9195', '#bcc0c3', '#575c60'], ['#2f5f9e', '#6390cb', '#1a3a66']];
    var CU = ['#c47a3a', '#e8a86c', '#7d4a1f'];
    var steps = cap ? (cap.getAttribute('data-steps') || '').split('|') : [];
    var W = 0, H = 0, cy = 0, d = 0, x0 = -40, x1 = 0, dpr = 1, step = -1;
    var clamp = function (x) { return Math.max(0, Math.min(1, x)); };
    var ease = function (t) { return t * t * (3 - 2 * t); };
    var lerp = function (a, b, t) { return a + (b - a) * t; };

    var band = function (xa, xb, h, fill) {
      var r = h / 2;
      ctx.beginPath();
      ctx.moveTo(xa, cy - r); ctx.lineTo(xb, cy - r);
      ctx.ellipse(xb, cy, r * 0.22, r, 0, -Math.PI / 2, Math.PI / 2);
      ctx.lineTo(xa, cy + r); ctx.closePath();
      ctx.fillStyle = fill; ctx.fill();
    };
    var stroke = function (pts, w, color, dy) {
      ctx.beginPath();
      pts.forEach(function (q, i) { if (i) ctx.lineTo(q[0], q[1] + dy); else ctx.moveTo(q[0], q[1] + dy); });
      ctx.lineWidth = w; ctx.strokeStyle = color; ctx.stroke();
    };

    var draw = function (p) {
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, W, H);
      if (!d) return;
      var t = ease(clamp(p / 0.4));
      var arm = ease(clamp((p - 0.4) / 0.28));
      var sh = ease(clamp((p - 0.62) / 0.3));
      var spin = ease(clamp(p / 0.6)) * Math.PI * 3;
      var R = d / Math.SQRT2, k = Math.PI * 2 / (d * 10), gap = d * 1.45;
      var xe = x1 - d * 1.4;
      var xa = lerp(x0, x1 - d * 6, arm), xs = lerp(x0, x1 - d * 10, sh);
      var from = Math.max(x0, xa - d * 2);
      ctx.lineCap = 'butt'; ctx.lineJoin = 'round';

      /* each core as runs split where it passes behind or in front, and where the copper starts */
      var runs = [];
      CORES.forEach(function (c, i) {
        var run = null;
        for (var x = from; x <= x1 + 0.1; x += 3) {
          var th = k * x + i * Math.PI / 2 + spin;
          var y = cy + lerp((i - 1.5) * gap, R * Math.cos(th), t);
          var front = Math.sin(th) * t >= 0, cu = x > xe;
          if (!run || run.front !== front || run.cu !== cu) {
            var last = run && run.pts[run.pts.length - 1];
            run = { front: front, cu: cu, col: cu ? CU : c, pts: last ? [last] : [] };
            runs.push(run);
          }
          run.pts.push([Math.min(x, x1), y]);
        }
      });
      [false, true].forEach(function (front) {
        runs.forEach(function (r) {
          if (r.front !== front || r.pts.length < 2) return;
          var w = r.cu ? d * 0.56 : d;
          stroke(r.pts, w + 2, r.col[2], 0);
          stroke(r.pts, w, r.col[0], 0);
          stroke(r.pts, w * 0.28, r.col[1], -w * 0.2);
        });
      });

      /* steel wire armour: a grey band of fine wires laid the opposite way */
      if (xa > x0 + 1) {
        var ha = 2 * R + d * 1.5;
        band(x0, xa, ha, '#7f868b');
        ctx.save();
        ctx.beginPath(); ctx.rect(x0, cy - ha / 2, xa - x0, ha); ctx.clip();
        ctx.lineWidth = Math.max(1.5, d * 0.13);
        for (var wx = x0 - ha; wx < xa + ha; wx += d * 0.3) {
          ctx.beginPath(); ctx.moveTo(wx, cy - ha / 2); ctx.lineTo(wx - ha * 0.55, cy + ha / 2);
          ctx.strokeStyle = 'rgba(220, 224, 227, 0.75)'; ctx.stroke();
        }
        var gA = ctx.createLinearGradient(0, cy - ha / 2, 0, cy + ha / 2);
        gA.addColorStop(0, 'rgba(255,255,255,0.25)'); gA.addColorStop(0.35, 'rgba(255,255,255,0)'); gA.addColorStop(1, 'rgba(0,0,0,0.35)');
        ctx.fillStyle = gA; ctx.fillRect(x0, cy - ha / 2, xa - x0, ha);
        ctx.restore();
      }

      /* outer sheath, pulled on from the left */
      if (xs > x0 + 1) {
        var hs = 2 * R + d * 2.2;
        band(x0, xs, hs, '#1b2533');
        var gS = ctx.createLinearGradient(0, cy - hs / 2, 0, cy + hs / 2);
        gS.addColorStop(0, 'rgba(255,255,255,0.05)'); gS.addColorStop(0.22, 'rgba(255,255,255,0.22)');
        gS.addColorStop(0.45, 'rgba(255,255,255,0)'); gS.addColorStop(1, 'rgba(0,0,0,0.3)');
        band(x0, xs, hs, gS);
      }

      var s = p < 0.12 ? 0 : p < 0.42 ? 1 : p < 0.66 ? 2 : 3;
      if (cap && s !== step && steps[s]) { step = s; cap.textContent = steps[s]; cap.dataset.step = s; }
    };

    var progress = function () {
      if (reduce) return 1;
      var r = hero.getBoundingClientRect(), span = r.height - window.innerHeight;
      return span > 0 ? clamp(-r.top / span) : 0;
    };
    var layout = function () {
      if (!wide.matches) { d = 0; return; }
      var r = pin.getBoundingClientRect();
      var card = hero.querySelector('.ep-hero__card'), kick = hero.querySelector('.ep-hero__main .ep-kicker');
      var top = card ? card.getBoundingClientRect().bottom - r.top : r.height * 0.35;
      var bot = kick ? kick.getBoundingClientRect().top - r.top : r.height * 0.62;
      W = r.width; H = r.height; dpr = Math.min(2, window.devicePixelRatio || 1);
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      d = Math.max(14, Math.min(34, (bot - top - 40) / 5.2));
      cy = (top + bot) / 2 - d * 0.4;
      x1 = W * 0.8;
      if (cap) {
        cap.style.top = (cy + d * 2.6) + 'px';
        cap.style.left = (kick ? kick.getBoundingClientRect().left - r.left : 48) + 'px';
      }
      draw(progress());
    };
    layout();
    window.addEventListener('resize', layout);
    window.addEventListener('load', layout);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
    onScroll(function () { if (d) draw(progress()); });
  });

  /* hero (gland version): a prepared armoured cable slides through a brass gland into the panel, the cores
     fan out to the terminals and the cap nut screws down onto the seal (wide screens) */
  document.querySelectorAll('[data-ep-gland]').forEach(function (hero) {
    var cv = hero.querySelector('.ep-twist');
    var pin = hero.querySelector('.ep-hero__pin');
    var cap = hero.querySelector('.ep-twist__step');
    if (!cv || !cv.getContext || !pin) return;
    var ctx = cv.getContext('2d');
    var wide = window.matchMedia('(min-width: 1000px)');
    var CORES = [['#7b4a2c', '#a8744e', '#3f2414'], ['#2b2b2b', '#5c5c5c', '#0d0d0d'], ['#8c9195', '#bcc0c3', '#575c60'], ['#2f5f9e', '#6390cb', '#1a3a66']];
    var CU = ['#c47a3a', '#e8a86c', '#7d4a1f'];
    var BRASS = [185, 138, 62];
    var steps = cap ? (cap.getAttribute('data-steps') || '').split('|') : [];
    var W = 0, H = 0, cy = 0, D = 0, top = 0, bot = 0, xw = 0, dpr = 1, step = -1;
    var clamp = function (x) { return Math.max(0, Math.min(1, x)); };
    var ease = function (t) { return t * t * (3 - 2 * t); };
    var lerp = function (a, b, t) { return a + (b - a) * t; };
    var brass = function (k) { return 'rgb(' + BRASS.map(function (c) { return Math.round(Math.min(255, c * k)); }).join(',') + ')'; };

    var rect = function (x, y, w, h, fill) { ctx.fillStyle = fill; ctx.fillRect(x, y, w, h); };
    var line = function (pts, w, color, dy) {
      ctx.beginPath();
      pts.forEach(function (q, i) { if (i) ctx.lineTo(q[0], q[1] + dy); else ctx.moveTo(q[0], q[1] + dy); });
      ctx.lineWidth = w; ctx.strokeStyle = color; ctx.stroke();
    };
    /* a hex seen side on: the faces turned towards us, shaded by angle; th turns it */
    var hex = function (xa, xb, r, th) {
      for (var k = 0; k < 6; k++) {
        var a1 = th + k * Math.PI / 3, a2 = a1 + Math.PI / 3, n = a1 + Math.PI / 6;
        if (Math.sin(n) <= 0.02) continue;
        var y1 = cy - r * Math.cos(a1), y2 = cy - r * Math.cos(a2);
        rect(xa, Math.min(y1, y2), xb - xa, Math.abs(y2 - y1) + 0.5, brass(0.62 + 0.3 * Math.sin(n) + 0.22 * Math.cos(n)));
      }
      rect(xa, cy - r, 1.5, r * 2, 'rgba(0,0,0,0.18)');
      rect(xb - 1.5, cy - r, 1.5, r * 2, 'rgba(0,0,0,0.18)');
    };
    var thread = function (xa, xb, h) {
      var g = ctx.createLinearGradient(0, cy - h / 2, 0, cy + h / 2);
      g.addColorStop(0, brass(1.15)); g.addColorStop(0.4, brass(0.95)); g.addColorStop(1, brass(0.55));
      rect(xa, cy - h / 2, xb - xa, h, g);
      ctx.lineWidth = 1.2; ctx.strokeStyle = 'rgba(70, 45, 10, 0.45)';
      for (var x = xa + 2; x < xb; x += D * 0.07) { ctx.beginPath(); ctx.moveTo(x, cy - h / 2); ctx.lineTo(x - D * 0.04, cy + h / 2); ctx.stroke(); }
    };

    var draw = function (p) {
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, W, H);
      if (!D) return;
      var slide = ease(clamp(p / 0.45)), turn = ease(clamp((p - 0.45) / 0.37)), done = p >= 0.84;
      /* gland parts, right to left: wall, body hex, neck thread, cap nut */
      var bodyR = xw, bodyL = xw - 0.9 * D, neckL = bodyL - 0.6 * D;
      var nutW = 0.9 * D, nutR = lerp(neckL, bodyL, turn), nutL = nutR - nutW;
      var xt = xw + 2.3 * D;
      /* cable: sheath end moves from left of the nut to inside it */
      var dc = D * 0.3, R = dc / Math.SQRT2, spread = D * 0.42;
      var sEnd1 = neckL + 0.15 * D, len = xt - (sEnd1 + 0.5 * D);
      var sEnd0 = nutL - 0.25 * D - len - 0.5 * D;
      var sEnd = lerp(sEnd0, sEnd1, slide) + turn * (bodyL - neckL) * 0.12;
      var aEnd = sEnd + 0.5 * D, tip = aEnd + len;

      /* inside the panel */
      rect(xw + 0.14 * D, top, xt + 0.9 * D - xw, bot - top, 'rgba(14, 30, 58, 0.05)');

      /* cores: laid up until past the wall, then fanned to the terminals */
      ctx.lineCap = 'butt'; ctx.lineJoin = 'round';
      var runs = [];
      CORES.forEach(function (c, i) {
        var run = null;
        for (var x = aEnd - 4; x <= tip + 0.1; x += 3) {
          var f = ease(clamp((x - xw - 0.4 * D) / (0.9 * D)));
          var th = (Math.PI * 2 / (dc * 10)) * (x - sEnd) + i * Math.PI / 2;
          var y = cy + lerp(R * Math.cos(th), (i - 1.5) * spread, f);
          var front = Math.sin(th) * (1 - f) >= 0, cu = x > tip - 0.35 * D;
          if (!run || run.front !== front || run.cu !== cu) {
            var last = run && run.pts[run.pts.length - 1];
            run = { front: front, cu: cu, col: cu ? CU : c, pts: last ? [last] : [] };
            runs.push(run);
          }
          run.pts.push([Math.min(x, tip), y]);
        }
      });
      [false, true].forEach(function (front) {
        runs.forEach(function (r) {
          if (r.front !== front || r.pts.length < 2) return;
          var w = r.cu ? dc * 0.56 : dc;
          line(r.pts, w + 2, r.col[2], 0); line(r.pts, w, r.col[0], 0); line(r.pts, w * 0.28, r.col[1], -w * 0.2);
        });
      });
      /* armour collar and sheath */
      var ha = D * 0.82;
      rect(sEnd - 2, cy - ha / 2, aEnd - sEnd + 2, ha, '#868d92');
      ctx.save(); ctx.beginPath(); ctx.rect(sEnd, cy - ha / 2, aEnd - sEnd, ha); ctx.clip();
      ctx.lineWidth = Math.max(1.5, D * 0.04); ctx.strokeStyle = 'rgba(225, 228, 230, 0.75)';
      for (var wx = sEnd - ha; wx < aEnd + ha; wx += D * 0.09) { ctx.beginPath(); ctx.moveTo(wx, cy - ha / 2); ctx.lineTo(wx - ha * 0.55, cy + ha / 2); ctx.stroke(); }
      ctx.restore();
      var gs = ctx.createLinearGradient(0, cy - D / 2, 0, cy + D / 2);
      gs.addColorStop(0, '#2a3546'); gs.addColorStop(0.25, '#3b4859'); gs.addColorStop(0.5, '#1b2533'); gs.addColorStop(1, '#0f151e');
      rect(-10, cy - D / 2, sEnd + 10, D, gs);
      ctx.beginPath(); ctx.ellipse(sEnd, cy, D * 0.08, D / 2, 0, -Math.PI / 2, Math.PI / 2); ctx.fillStyle = '#1b2533'; ctx.fill();

      /* terminal block: screws go red once the gland is tight */
      var tb = spread * 4 + D * 0.1;
      rect(xt - 0.12 * D, cy - tb / 2, 0.55 * D, tb, '#d9dcdf');
      rect(xt - 0.12 * D, cy - tb / 2, 0.55 * D, 2, '#b4b9bd');
      for (var i = 0; i < 4; i++) {
        var sy = cy + (i - 1.5) * spread;
        rect(xt - 0.12 * D, sy + spread / 2 - 1, 0.55 * D, 2, '#b4b9bd');
        ctx.beginPath(); ctx.arc(xt + 0.2 * D, sy, D * 0.09, 0, Math.PI * 2);
        ctx.fillStyle = done ? '#d63b50' : '#9ba1a6'; ctx.fill();
      }

      /* panel wall, locknut and entry thread */
      rect(xw, top, 0.14 * D, bot - top, '#c3c8cc');
      rect(xw + 0.14 * D - 2, top, 2, bot - top, '#a3a9ae');
      thread(xw, xw + 0.55 * D, D * 1.15);
      hex(xw + 0.14 * D, xw + 0.38 * D, D * 0.85, 0);
      /* gland body and neck */
      hex(bodyL, bodyR, D * 0.92, 0);
      thread(neckL, bodyL, D * 1.2);
      /* cap nut with its seal lip */
      hex(nutL, nutR, D * 0.9, turn * Math.PI * 4);
      var lip = lerp(D * 1.18, D * 1.03, turn);
      rect(nutL - D * 0.05, cy - lip / 2, D * 0.06, lip, '#141414');

      var s = p < 0.1 ? 0 : p < 0.45 ? 1 : p < 0.84 ? 2 : 3;
      if (cap && s !== step && steps[s]) { step = s; cap.textContent = steps[s]; cap.dataset.step = s; }
    };

    var progress = function () {
      if (reduce) return 1;
      var r = hero.getBoundingClientRect(), span = r.height - window.innerHeight;
      return span > 0 ? clamp(-r.top / span) : 0;
    };
    var layout = function () {
      if (!wide.matches) { D = 0; return; }
      var r = pin.getBoundingClientRect();
      var card = hero.querySelector('.ep-hero__card'), kick = hero.querySelector('.ep-hero__main .ep-kicker');
      top = (card ? card.getBoundingClientRect().bottom - r.top : r.height * 0.35) + 12;
      bot = (kick ? kick.getBoundingClientRect().top - r.top : r.height * 0.62) - 34;
      W = r.width; H = r.height; dpr = Math.min(2, window.devicePixelRatio || 1);
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      D = Math.max(48, Math.min(110, (bot - top) / 2));
      cy = (top + bot) / 2;
      xw = W * 0.6;
      if (cap) {
        cap.style.top = (bot + 6) + 'px';
        cap.style.left = (kick ? kick.getBoundingClientRect().left - r.left : 48) + 'px';
      }
      draw(progress());
    };
    layout();
    window.addEventListener('resize', layout);
    window.addEventListener('load', layout);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
    onScroll(function () { if (D) draw(progress()); });
  });

  /* hero (plan version): the background is a faint electrical site plan. While the pinned hero scrolls,
     bundles of cable lay themselves along the trays, then a red dash-dot cable route draws across and the
     text on the right darkens word by word. Phones and reduced motion get the finished drawing. */
  document.querySelectorAll('[data-ep-plan]').forEach(function (hero) {
    var svg = hero.querySelector('.ep-plan');
    if (!svg) return;
    var NS = 'http://www.w3.org/2000/svg';
    var pinned = window.matchMedia('(min-width: 1000px) and (prefers-reduced-motion: no-preference)');
    var clamp = function (x) { return Math.max(0, Math.min(1, x)); };
    var lerp = function (a, b, t) { return a + (b - a) * t; };
    var el = function (parent, tag, attrs, text) {
      var e = document.createElementNS(NS, tag);
      Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); });
      if (text) e.textContent = text;
      parent.appendChild(e);
      return e;
    };

    var run = epRun;

    /* base drawing: grid, plant rooms and building outlines, draw-pits */
    var base = el(svg, 'g', { class: 'ep-plan__base ep-plan__layer' });
    for (var gx = -96; gx <= 1536; gx += 48) el(base, 'path', { d: 'M' + gx + ' -96V996', class: 'ep-plan__grid' });
    for (var gy = -96; gy <= 996; gy += 48) el(base, 'path', { d: 'M-96 ' + gy + 'H1536', class: 'ep-plan__grid' });
    EP_ROOMS.forEach(function (b) {
      el(base, 'rect', { x: b[0], y: b[1], width: b[2], height: b[3], class: 'ep-plan__room' });
      el(base, 'text', { x: b[0] + 10, y: b[1] + 20, class: 'ep-plan__label' }, b[4]);
    });
    EP_PITS.forEach(function (m) {
      el(base, 'rect', { x: m[0] - 9, y: m[1] - 9, width: 18, height: 18, class: 'ep-plan__pit' });
    });

    /* cable bundles: a lead cable and three beside it, laid along a tray */
    var BUNDLES = EP_BUNDLES;
    var mid = el(svg, 'g', { class: 'ep-plan__layer' });
    var groups = BUNDLES.map(function (pts) {
      var g = el(mid, 'g', { class: 'ep-plan__bundle' });
      [0, 11, 22, 33].forEach(function (o, i) {
        el(g, 'path', { d: run(pts, o, 40), pathLength: 1, class: i ? 'ep-plan__cable' : 'ep-plan__cable ep-plan__cable--lead' });
      });
      return g;
    });

    /* the cable route: red dash-dot, revealed through a mask so the dashes keep their rhythm */
    var ROUTE = EP_ROUTE;
    var rd = run(ROUTE, 0, 40);
    var defs = el(svg, 'defs', {});
    var mask = el(defs, 'mask', { id: 'ep-plan-mask', maskUnits: 'userSpaceOnUse', x: 0, y: 0, width: 1440, height: 900 });
    var reveal = el(mask, 'path', { d: rd, pathLength: 1, class: 'ep-plan__reveal' });
    var front = el(svg, 'g', { class: 'ep-plan__layer' });
    el(front, 'path', { d: rd, class: 'ep-plan__route', mask: 'url(#ep-plan-mask)' });
    var end = el(front, 'g', { class: 'ep-plan__end' });
    el(end, 'circle', { cx: 220, cy: 480, r: 14 });
    el(end, 'circle', { cx: 220, cy: 480, r: 5, class: 'ep-plan__end-dot' });
    if (svg.getAttribute('data-end-label')) el(end, 'text', { x: 246, y: 485, class: 'ep-plan__end-label' }, svg.getAttribute('data-end-label'));

    /* side text: each word darkens in turn */
    var para = hero.querySelector('[data-ep-words]') || hero.querySelector('.ep-hero__side p');
    var stepEls = hero.querySelectorAll('.ep-hero__steps li');
    /* a click on a stage dot scrolls to the middle of that stage */
    Array.prototype.forEach.call(stepEls, function (li, i) {
      li.addEventListener('click', function () {
        var span = hero.offsetHeight - window.innerHeight;
        var top = hero.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: top + span * [0.12, 0.46, 0.82][i], behavior: 'smooth' });
      });
    });
    var words = [];
    if (para && !reduce) {
      var text = para.textContent.trim().split(/\s+/);
      para.textContent = '';
      text.forEach(function (w, i) {
        var s = document.createElement('span'); s.className = 'ep-word'; s.textContent = w;
        para.appendChild(s); if (i < text.length - 1) para.appendChild(document.createTextNode(' '));
        words.push(s);
      });
      para.setAttribute('aria-label', text.join(' '));
    }

    /* mouse depth: the plan, the bundles and the route drift away from the mouse by different amounts */
    if (!reduce && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var layers = [[base, 24], [mid, 36], [front, 70]];
      /* test probe: the bundle nearest the mouse goes live (red) while the mouse is within reach of it */
      var samples = groups.map(function (g) {
        var lead = g.firstChild, len = lead.getTotalLength(), pts = [];
        for (var u = 0; u <= len; u += 16) { var q = lead.getPointAtLength(u); pts.push([q.x, q.y, u / len]); }
        return pts;
      });
      var probe = function (e) {
        var m = mid.getScreenCTM();
        if (!m) return;
        var pt = svg.createSVGPoint(); pt.x = e.clientX; pt.y = e.clientY;
        var v = pt.matrixTransform(m.inverse()), best = -1, bd = 70;
        samples.forEach(function (pts, i) {
          var drawn = 1 - parseFloat(groups[i].firstChild.style.strokeDashoffset || 1);
          pts.forEach(function (q) {
            if (q[2] > drawn) return;
            var dd = Math.hypot(q[0] - v.x, q[1] - v.y);
            if (dd < bd) { bd = dd; best = i; }
          });
        });
        groups.forEach(function (g, i) { g.classList.toggle('is-live', i === best); });
      };
      hero.addEventListener('mousemove', probe, { passive: true });
      hero.addEventListener('mouseleave', function () { groups.forEach(function (g) { g.classList.remove('is-live'); }); });
      var mx = 0, my = 0, cx = 0, cy = 0, going = false;
      var drift = function () {
        cx += (mx - cx) * 0.06; cy += (my - cy) * 0.06;
        layers.forEach(function (l) { l[0].setAttribute('transform', 'translate(' + (-cx * l[1]).toFixed(2) + ' ' + (-cy * l[1]).toFixed(2) + ')'); });
        if (Math.abs(mx - cx) + Math.abs(my - cy) > 0.002) window.requestAnimationFrame(drift); else going = false;
      };
      hero.addEventListener('mousemove', function (e) {
        mx = e.clientX / window.innerWidth - 0.5; my = e.clientY / window.innerHeight - 0.5;
        if (!going) { going = true; window.requestAnimationFrame(drift); }
      }, { passive: true });
    }

    var set = function (path, f) { path.style.strokeDashoffset = (1 - f).toFixed(4); };
    onScroll(function () {
      var p = 1;
      if (pinned.matches) {
        var r = hero.getBoundingClientRect(), span = r.height - window.innerHeight;
        p = span > 0 ? clamp(-r.top / span) : 0;
      }
      var f = [lerp(0.4, 1, clamp(p / 0.35)), lerp(0.2, 1, clamp((p - 0.1) / 0.35)), clamp((p - 0.25) / 0.35)];
      groups.forEach(function (g, i) { Array.prototype.forEach.call(g.children, function (c, k) { set(c, clamp(f[i] - k * 0.015)); }); });
      set(reveal, clamp((p - 0.5) / 0.42));
      end.classList.toggle('is-on', p >= 0.92);
      var stage = p < 0.33 ? 0 : p < 0.6 ? 1 : 2;
      Array.prototype.forEach.call(stepEls, function (li, i) { li.classList.toggle('is-active', i === stage); });
      /* words not reached yet are hidden; the first two show from the start, the rest fade in (and back out on the way up) */
      var at = 5 + clamp(p / 0.85) * words.length;
      words.forEach(function (w, i) { w.style.opacity = pinned.matches ? clamp((at - i) / 3).toFixed(3) : ''; });
    });
  });

  /* card labels: over a card a small label follows the mouse, naming what the click does. Nothing follows
     the mouse anywhere else, and the normal cursor stays. Mouse and trackpad only. */
  (function () {
    if (reduce || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var LABELS = [['.ep-type', 'View range'], ['.ep-guide', 'Read guide'], ['.ep-hero__card', 'Read guide']];
    var dot = document.createElement('div');
    dot.className = 'ep-cursor';
    dot.setAttribute('aria-hidden', 'true');
    dot.innerHTML = '<span class="ep-cursor__label"></span>';
    document.body.appendChild(dot);
    var label = dot.querySelector('.ep-cursor__label');
    var x = -100, y = -100, tx = -100, ty = -100, running = false;
    var loop = function () {
      x += (tx - x) * 0.2; y += (ty - y) * 0.2;
      dot.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
      if (Math.abs(tx - x) + Math.abs(ty - y) > 0.3) window.requestAnimationFrame(loop); else running = false;
    };
    window.addEventListener('mousemove', function (e) {
      tx = e.clientX; ty = e.clientY;
      if (!running) { running = true; window.requestAnimationFrame(loop); }
    }, { passive: true });
    document.addEventListener('mouseleave', function () { dot.classList.remove('is-label'); });
    document.addEventListener('mouseover', function (e) {
      var text = '';
      for (var i = 0; i < LABELS.length && !text; i++) if (e.target.closest && e.target.closest(LABELS[i][0])) text = LABELS[i][1];
      if (text && !dot.classList.contains('is-label')) { x = tx; y = ty; dot.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)'; }
      if (text) label.textContent = text;
      dot.classList.toggle('is-label', !!text);
    });
  })();

  /* closing prompt: the first time it scrolls into view, the heading and line fade in word by word, then the
     buttons. Once only; nothing is hidden without JS or with reduced motion. */
  (function () {
    var cta = document.querySelector('.ep-cta');
    if (!cta || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var n = 0;
    cta.querySelectorAll('.ep-cta__box h2, .ep-cta__box > p').forEach(function (el) {
      var parts = el.textContent.trim().split(/\s+/);
      el.textContent = '';
      parts.forEach(function (w, i) {
        var s = document.createElement('span');
        s.className = 'ep-cta__w';
        s.style.setProperty('--i', n++);
        s.textContent = w;
        el.appendChild(s);
        if (i < parts.length - 1) el.appendChild(document.createTextNode(' '));
      });
    });
    var row = cta.querySelector('.ep-cta__box .ep-row');
    if (row) row.style.setProperty('--i', n + 2);
    cta.classList.add('is-armed');
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      cta.classList.add('is-in');
      io.disconnect();
    }, { threshold: 0.45 });
    io.observe(cta.querySelector('.ep-cta__box') || cta);
  })();

  /* mobile menu: opening Products, Services or Resources slides the group open, and its headings and links slide
     in from the right one after another; closing eases them back out and folds the group shut. Plain <details> without JS or with reduced motion. */
  if (!reduce && Element.prototype.animate) {
    document.querySelectorAll('.ech__sheet details').forEach(function (d) {
      var summary = d.querySelector('summary');
      var body = d.querySelector('.ech__sheet-group');
      if (!summary || !body) return;
      var running = null;
      var ease = 'cubic-bezier(0.25, 0.6, 0.3, 1)';
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        body.getAnimations({ subtree: true }).forEach(function (an) { an.cancel(); });
        running = null;
        body.style.overflow = 'hidden';
        if (!d.open) {
          d.open = true;
          var h = body.offsetHeight;
          running = body.animate([{ height: '0px' }, { height: h + 'px' }], { duration: 420, easing: ease });
          body.querySelectorAll('h3, a').forEach(function (el, i) {
            el.animate([{ opacity: 0, transform: 'translateX(32px)' }, { opacity: 1, transform: 'none' }],
              { duration: 420, delay: 40 + Math.min(i, 12) * 35, easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)', fill: 'backwards' });
          });
        } else {
          /* the rows in view drift right and fade while the group folds up */
          var top = summary.getBoundingClientRect().bottom, vh = window.innerHeight;
          body.querySelectorAll('h3, a').forEach(function (el) {
            var r = el.getBoundingClientRect();
            if (r.bottom < top || r.top > vh) return;
            el.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateX(24px)' }],
              { duration: 220, easing: 'cubic-bezier(0.55, 0, 1, 0.45)', fill: 'forwards' });
          });
          running = body.animate([{ height: body.offsetHeight + 'px' }, { height: '0px' }], { duration: 460, delay: 80, easing: 'cubic-bezier(0.65, 0, 0.35, 1)', fill: 'forwards' });
          running.onfinish = function () {
            d.open = false;
            body.getAnimations({ subtree: true }).forEach(function (a) { a.cancel(); });
          };
        }
        running.addEventListener('finish', function () { body.style.overflow = ''; running = null; });
      });
    });
  }

  /* intro film (sections/ep-film.liquid): scenes play in turn, each for its data-dur; the bar below shows
     where it is. Starts when the card is on screen, stops when it leaves, loops; play/pause and the bar
     segments control it. Reduced motion: no autoplay, scenes change by the controls only. */
  document.querySelectorAll('[data-ep-film-section]').forEach(function (sec) {
    var card = sec.querySelector('[data-ep-film]');
    if (!card) return;
    var scenes = Array.prototype.slice.call(card.querySelectorAll('[data-scene]'));
    var ticks = Array.prototype.slice.call(card.querySelectorAll('.ep-film__ticks li'));
    var playBtn = card.querySelector('[data-ep-film-play]');
    var at = -1, timer = 0, startedAt = 0, left = 0, playing = false, inView = false, userPaused = reduce;
    var counter = card.querySelector('[data-ep-count]'), countTimer = 0;

    var runCount = function (scene) {
      clearInterval(countTimer);
      if (!counter || !scene.contains(counter)) return;
      var to = parseInt(counter.getAttribute('data-ep-count'), 10) || 0;
      if (reduce) { counter.textContent = to; return; }
      var t0 = Date.now(), wait = 400, dur = 3200;
      counter.textContent = '0';
      countTimer = setInterval(function () {
        if (!playing) return;
        var k = Math.min(1, Math.max(0, (Date.now() - t0 - wait) / dur));
        var e = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
        counter.textContent = Math.round(to * e);
        if (k >= 1) clearInterval(countTimer);
      }, 40);
    };
    var show = function (i) {
      at = (i + scenes.length) % scenes.length;
      scenes.forEach(function (s, k) {
        if (k === at) { s.classList.remove('is-on'); void s.offsetWidth; s.classList.add('is-on'); }
        else s.classList.remove('is-on');
      });
      ticks.forEach(function (t, k) {
        t.classList.toggle('is-done', k < at);
        t.classList.remove('is-on');
        if (k === at) { t.style.setProperty('--dur', scenes[at].getAttribute('data-dur') + 'ms'); void t.offsetWidth; t.classList.add('is-on'); }
      });
      left = parseInt(scenes[at].getAttribute('data-dur'), 10) || 5000;
      runCount(scenes[at]);
    };
    var schedule = function () {
      clearTimeout(timer);
      if (!playing) return;
      startedAt = Date.now();
      timer = setTimeout(function () { show(at + 1); schedule(); }, left);
    };
    var setPlaying = function (on) {
      if (on === playing) return;
      if (!on && playing) left = Math.max(0, left - (Date.now() - startedAt));
      playing = on;
      sec.classList.toggle('is-paused', !on);
      playBtn.setAttribute('aria-label', on ? 'Pause film' : 'Play film');
      playBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) { sec.classList.add('is-live'); if (at < 0) show(0); schedule(); }
      else clearTimeout(timer);
    };

    show(0);
    if (reduce) { sec.classList.add('is-paused'); playBtn.setAttribute('aria-label', 'Play film'); playBtn.setAttribute('aria-pressed', 'false'); }
    else { playing = false; sec.classList.add('is-paused'); }

    playBtn.addEventListener('click', function () {
      if (reduce) { show(at + 1); return; }
      userPaused = playing;
      setPlaying(!playing);
    });
    card.querySelectorAll('[data-ep-film-go]').forEach(function (b) {
      b.addEventListener('click', function () {
        show(parseInt(b.getAttribute('data-ep-film-go'), 10));
        if (playing) schedule();
      });
    });
    if ('IntersectionObserver' in window && !reduce) {
      new IntersectionObserver(function (es) {
        inView = es[0].isIntersecting;
        if (inView && !userPaused) { if (!sec.classList.contains('is-live')) show(0); setPlaying(true); }
        else if (!inView) setPlaying(false);
      }, { threshold: 0.45 }).observe(card);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) setPlaying(false);
      else if (inView && !userPaused) setPlaying(true);
    });
  });

  /* where our cable goes: arrow buttons move the card row by one card, and switch off at either end */
  document.querySelectorAll('[data-ep-reel]').forEach(function (sec) {
    var track = sec.querySelector('[data-ep-reel-track]');
    var prev = sec.querySelector('[data-ep-reel-prev]'), next = sec.querySelector('[data-ep-reel-next]');
    if (!track || !prev || !next) return;
    var step = function () {
      var item = track.querySelector('.ep-reel__item');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    };
    var sync = function () {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    var go = function (dir) { track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' }); };
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
})();
